import { useQuery } from 'react-query';
import api from '@/utils/httpClient';

export interface TreatmentHistoryDto {
	id: string;
	treatmentType: string;
	treatmentDescription: string;
	eventName: string;
	startDate?: Date;
	endDate?: Date;
	status: string;
	comments: string;
	sortOrder?: number;
}

export const getTreatmentHistoriesForPatient = (patientId: string | undefined) => {
  return api
    .get(`/api/treatmenthistories/${patientId}/treatmentHistories`)
    .then((response) => response.data as TreatmentHistoryDto[]);
};

export const useGetTreatmentHistories = (patientId: string | undefined) => {
  return useQuery(
    ['treatmentHistories', patientId],
    () => getTreatmentHistoriesForPatient(patientId),
    {
      enabled: !!patientId
    }
  );
};
